module.exports = __webpack_public_path__ + "img/article-icon-103.25ffe8e1.svg";